import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import FeatherIcon from 'feather-icons-react'
import { useMemo, useState } from 'react'
import type { Feature, PricePlanTemplate, TemplateFeature } from '../types'
import { Features } from './Features'

interface TemplateDetailProps {
  template: PricePlanTemplate
  allFeatures: Feature[]
  navigateBack: () => void
  onSave: (features: TemplateFeature[]) => Promise<boolean>
}

export const TemplateDetail = ({ template, allFeatures, navigateBack, onSave }: TemplateDetailProps) => {
  const [localFeatures, setLocalFeatures] = useState<TemplateFeature[]>(template.features)

  const hasChanges = useMemo(() => {
    return !Object.is(localFeatures, template.features)
  }, [localFeatures, template])

  const updateLocalFeatures = (newLocalFeatures: TemplateFeature[]) => {
    setLocalFeatures([...newLocalFeatures])
  }

  const handleSave = async () => {
    try {
      const saveResultSuccess = await onSave(localFeatures)

      if (saveResultSuccess) {
        navigateBack()
      } else {
        console.error('Failed to save template: Unknown error')
      }
    } catch (error) {
      console.error('Failed to save template:', error)
    }
  }

  return (
    <Stack width="100%" spacing="32px" sx={{ pt: '32px' }}>
      <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center" sx={{ pb: '24px' }}>
        <Stack direction="row" alignItems="center" spacing="16px">
          <IconButton size="small" onClick={navigateBack}>
            <FeatherIcon icon="arrow-left" size={16} />
          </IconButton>
          <Typography variant="h4">{template.name}</Typography>
        </Stack>
        <Button variant="contained" onClick={handleSave} disabled={!hasChanges}>
          Save
        </Button>
      </Stack>

      <Features localFeatures={localFeatures} allFeatures={allFeatures} updateLocalFeatures={updateLocalFeatures} />
    </Stack>
  )
}
